import { axiosPost } from '@/api/AxiosApi';

// 휴면계정 해제
export const disableDormantAcct = async ({ code }: { code: string }) => {
  const payload = {
    path: '/v1/users/dormantTermination',
    body: { auth_num: code },
  };
  const { data: re } = await axiosPost(payload);
  return re;
};
